import React, { useEffect, useState } from 'react';

import type { CoreEnv, CoreUser } from '@eventbrite/legacy-infra.context-types';
import { GlobalNav } from '@eventbrite/consumer-header.global-nav';
import { ConsumerHeader } from '@eventbrite/consumer-header.consumer-header';
import styles from './GlobalHeader.module.scss';
import type {
    RequestShape,
    IntentToggleProps,
    FeatureFlags,
    searchBarProps,
} from '@eventbrite/consumer-header.global-nav/types';

export interface GlobalHeaderProps {
    env: Partial<CoreEnv> & {
        launchNewSignInSignUpLinks?: boolean;
        isManageOverviewActive?: boolean;
    };
    request: RequestShape;
    isHomePage?: boolean;
    intentToggle?: IntentToggleProps;
    featureFlags?: FeatureFlags;
    searchBar?: searchBarProps;
    /**
     * If true, the user will not be fetched from the API.
     * This prevents adding pressure to the homepage BFF.
     */
    disableFetchUser?: boolean;
}

const getUser: () => Promise<{ user: CoreUser | null }> = async () => {
    try {
        const response = await fetch('/home/api/user/');
        if (!response.ok) {
            throw new Error(`Failed to fetch user: ${response.statusText}`);
        }
        const user = await response.json();
        return user;
    } catch (e) {
        console.error('Error fetching user:', e);
        return { user: null };
    }
};

export const GlobalHeader: React.FunctionComponent<GlobalHeaderProps> = ({
    env,
    request,
    isHomePage,
    intentToggle,
    featureFlags,
    searchBar,
    disableFetchUser,
}) => {
    let header;
    //FIXME: fix types
    const coreEnv = env as CoreEnv;
    const [user, setUser] = useState<CoreUser | null>(null);

    useEffect(() => {
        if (!disableFetchUser) {
            const fetchUser = async () => {
                const { user } = await getUser();
                setUser(user);
            };
            fetchUser();
        }
    }, [disableFetchUser]);

    if (user) {
        header = (
            <ConsumerHeader
                env={coreEnv}
                request={request}
                user={user}
                isHomePage={isHomePage}
                featureFlags={featureFlags ?? {}}
                searchBar={searchBar}
            />
        );
    } else {
        header = (
            <GlobalNav user={{}} env={env} intentToggle={intentToggle} searchBar={searchBar} />
        );
    }

    return <div className={styles.root}>{header}</div>;
};
